import cleanedFilename from '~/util/cleanedFilename';

export default {
  NAME: `${cleanedFilename(__filename)}-name`,
  ACCOUNT_ID: `${cleanedFilename(__filename)}-account-id`,
  STATUS: `${cleanedFilename(__filename)}-status`,
  ISSUES: `${cleanedFilename(__filename)}-issues`,
};
